import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UserAvatar from "./UserAvatar";
import { LANGUAGE_FLAGS } from "../../config/Common";
import _ from "i18n";
import ThemeActions from "./ThemeActions";
import { setCurrentDndTheme, setCurrentSimpleTheme } from "actions";
import SendTestForm from "../common/SendTestForm";
import { sendThemeTest } from "../../actions/thunks/theme";
import { onError, onSuccess } from "utils";

const ThemeItem = (props) => {
  const [showSendThemeTest, setShowSendThemeTest] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loggedAs = useSelector((state) => state.auth.loggedAs);
  const updating = useSelector((state) => state.themes.updating);

  const toggleTestForm = () => setShowSendThemeTest((prev) => !prev);

  const useTheme = (action) => {
    const {
      id,
      name,
      content,
      design,
      language,
      object,
      isPublic,
      main,
      gdprThemeId,
      type,
      targetApp,
      themeCategory,
      organization,
      sendMode,
      associatedNotSentCampaigns,
    } = props;

    const theme = {
      name,
      content,
      design,
      language,
      object,
      isPublic,
      main,
      gdprThemeId,
      type,
      targetApp,
      themeCategory,
      organization,
      sendMode,
      associatedNotSentCampaigns,
    };

    if (action === "EDIT") {
      theme.id = id;
    }

    if (type === "SIMPLE") {
      dispatch(setCurrentSimpleTheme(theme));
      navigate(`/templates/${id}`);
    } else {
      dispatch(setCurrentDndTheme(theme));
      navigate(`/drag-drop`);
    }
  };

  const sendTestTheme = (recipients) => {
    const { id, content } = props;
    const data = { id, html: content, emails: recipients };

    dispatch(sendThemeTest(data)).then(
      (res) => {
        toggleTestForm();
        onSuccess(res);
      },
      (err) => onError(err),
    );
  };

  const {
    name,
    originality,
    language,
    organization,
    updatedAt,
    updatedBy,
    preview,
    onSettingClick,
    isPublic,
    actif,
    isUaNewsletter,
    useThemeUa,
  } = props;

  return (
    <div
      className={`small-6 theme__item-container ${
        isUaNewsletter ? "theme-ua" : ""
      }`}
    >
      <div className={`theme__item`}>
        <div
          className={`theme__item__preview ${actif === 2 ? "masked" : ""}`}
          style={{
            backgroundImage: `url(${preview || "img/theme/no-theme.png"})`,
          }}
        />
        <div className="theme__item__status">
          <div className="item-name">
            {name}
            <span className="item-lng">
              {LANGUAGE_FLAGS[language] && (
                <span className={`flag-icon ${LANGUAGE_FLAGS[language]}`} />
              )}
            </span>
          </div>
          <div className="item-tags">
            <span className="item-tag">
              <i className={isPublic ? "icon-share" : "icon-lock"} />
              {isPublic ? _("shared") : _("private")}
            </span>
            <span className="item-tag">
              <i className="icon-tag" />
              {_(originality)}
            </span>
          </div>
          <UserAvatar updatedAt={updatedAt} updatedBy={updatedBy} />
          <ThemeActions
            loggedAs={loggedAs}
            {...props}
            onSettingClick={onSettingClick}
            organization={organization}
            useTheme={() => useTheme("USE")}
            editTheme={() => useTheme("EDIT")}
            sendTestTheme={toggleTestForm}
            isUaNewsletter={isUaNewsletter}
            useThemeUa={useThemeUa}
          />
          {showSendThemeTest && (
            <SendTestForm
              processing={updating}
              onCloseModal={toggleTestForm}
              onSave={sendTestTheme}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ThemeItem;
